import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  data: {
    orderNumber: "",
    orderDate: "",
    orderAmount: 0,
    orderForm: 37,
    orderStatus: 1,
    serviceOption: 0,
    sampleAmount: "",
    dropBoxId: null,
    dropBoxDate: "",
    comments: "",
    tableData: [],
  },
  billingInformation: {
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    email: "",
    shippingOption: "Dropbox",
    dropboxLocation: "",
    dropoffDate: "",
    billingMethod: "",
    purchasingAgentName: "",
    purchasingAgentEmail: "",
    poNumber: "",
    grantNumber:"",
    grantPi:"",
    grantNote:"",
    ccNumber: "",
    ccMonth: "",
    ccYear: "",
    cvv: "",
	ccZip: "",
    cardType: "",
    ccName: "",
    acgtCard: "",
  },
  primer: {
    primerList: [],
    primerAmount: "",
    banking: null,
    primerSynthesisList: [],
    synthesis: null,
  },
};

const ngsFormSlice = createSlice({
  name: "ngsorderform",
  initialState,
  reducers: {
    //action creators
    initializeNgsTableData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newObj = {
          id: i + 1,
          sampleID: "",
          sampleType: "",
          targetType: "",
          targetSize: 0,
          dataAnalysis: "",
          orderId: 0,
        };
        state.data.tableData.push(newObj);
      }
      return;
    },
    resetNgsState(state, action) {
      Object.assign(state, initialState);
      return;
    },
    resetNgsTableData(state, action) {
      state.data.tableData = action.payload;
      return;
    },
    setNgsSampleAmount(state, action) {
      state.data.sampleAmount = parseInt(action.payload);
      return;
    },
    addNgsRow(state, action) {
      const newRow = action.payload;
      // Add the new row to the end of tableData
      state.data.tableData.push(newRow);

      // Reset the indices in the updated tableData
      state.data.tableData = state.data.tableData.map((item, index) => ({
        ...item,
        id: index + 1,
      }));
      state.data.sampleAmount = parseInt(state.data.sampleAmount + 1);
      return;
    },
    editNgsRow(state, action) {
      const { index, value, property } = action.payload;
      let pattern = /^[a-zA-Z0-9-_]{0,20}$/;
      const updatedData = [...state.data.tableData];

      if (property === "dName" || property === "pName") {
        if (pattern.test(value)) {
          updatedData[index][property] = value;
        } else {
          // You may want to handle this case differently, e.g., show an error message
          alert(
            "Only special characters allowed: hyphen( - ) and underscore( _ )."
          );
          return;
        }
      } else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.data.tableData = updatedData;
    },
    copyNgsRow(state, action) {
      const { index } = action.payload;
      const rowToCopy = state.data.tableData[index];

      // Create a copy of the row with a new id
      const copiedRow = {
        ...rowToCopy,
        id: state.data.tableData.length + 1, // Assign a new id or adjust as needed
      };

      // Insert the copied row at a specific position (e.g., next to the original row)
      state.data.tableData.splice(index + 1, 0, copiedRow);

      // Reset the indices in the updated tableData
      state.data.tableData = state.data.tableData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));
      state.data.sampleAmount = parseInt(state.data.sampleAmount + 1);
      return;
    },
    deleteNgsRow(state, action) {
      const { index } = action.payload;
      const updatedTableData = state.data.tableData.filter(
        (item, i) => i !== index
      );

      // Reset the indices in the updated tableData
      const resetIndexedTableData = updatedTableData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));

      // Update the tableData state
      state.data.tableData = resetIndexedTableData;
      state.data.sampleAmount = parseInt(state.data.sampleAmount - 1);
      return;
    },
    toggleNgsCheckbox(state, action) {
      const { index, property } = action.payload;
      const newData = [...state.data.tableData];
      newData[index][property] = !newData[index][property];
      state.data.tableData = newData;
    },
    increaseNgsConcentration(state, action) {
      const { index, property } = action.payload;
      state.data.tableData[index][property] += 1;
    },
    decreaseNgsConcentration(state, action) {
      const { index, property } = action.payload;
      if (state.data.tableData[index][property] > 0) {
        state.data.tableData[index][property] -= 1;
      }
    },
    clearNgsSelect(state, action) {
      const { index, property } = action.payload;

      state.data.tableData[index] = {
        ...state.data.tableData[index],
        [property]: "", // Set the specified property to an empty string for the specific row
      };

      return;
    },
    ngsPrevStep: (state, action) => {
      state.page = state.page - 1;
    },
    ngsNextStep: (state, action) => {
      state.page = state.page + 1;
    },
    ngsSetStep: (state, action) => {
      state.page = action.payload;
    },
    resetNgsPage: (state, action) => {
      state.page = action.payload;
    },
    initializeNgsPrimerTableData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newObj = {
          id: i + 1,
          pName: "",
          pSequence: "",
        };
        state.primer.primerSynthesisList.push(newObj);
      }
      return;
    },
    setNgsPrimerAmount(state, action) {
      state.primer.primerAmount = parseInt(action.payload);
      return;
    },
    addNgsPrimerRow: (state, action) => {
      const newRow = action.payload;
      // Add the new row to the end of tableData
      state.primer.primerSynthesisList.push(newRow);

      // Reset the indices in the updated tableData
      state.primer.primerSynthesisList = state.primer.primerSynthesisList.map(
        (item, index) => ({
          ...item,
          id: index + 1,
        })
      );
      state.primer.primerAmount = parseInt(state.primer.primerAmount + 1);
      return;
    },
    editNgsPrimerRow(state, action) {
      const { index, property, value } = action.payload;
      let pattern = /^[a-zA-Z0-9_-]*$/;
      const updatedData = [...state.primer.primerSynthesisList];

      if (property === "pSequence" || property === "pName") {
        if (pattern.test(value)) {
          updatedData[index][property] = value;
        } else {
          return;
        }
      } else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.primer.primerSynthesisList = updatedData;
    },
    deleteAllNgsPrimer(state, action) {
      state.primer.primerSynthesisList = action.payload;
      state.primer.primerAmount = "";
      return;
    },
    setNgsPrimerBanking(state, action) {
      state.primer.banking = action.payload;
      return;
    },
    setNgsPrimerList(state, action) {
      const list = action.payload.split(/,\s|\n|,/);
      state.primer.primerList = list;
      // console.log(state.primer.primerList);
      return;
    },
    setNgsPrimerSynthesis(state, action) {
      state.primer.synthesis = action.payload;
      return;
    },
    setNgsComments(state, action) {
      state.data.comments = action.payload;
      return;
    },
    setNgsDropboxLocation(state, action) {
      state.billingInformation.dropboxLocation = action.payload.label;
      return;
    },
    setNgsDropboxId(state, action) {
      state.data.dropBoxId = action.payload
      return;
    },
    setNgsDropoffDate(state, action) {
      state.billingInformation.dropoffDate = action.payload;
      state.data.dropBoxDate = action.payload;
      // Test the regular expression with a date
      // if (dateRegex.test(result)) {
      // }
    },
    setNgsFirstName(state, action) {
      state.billingInformation.firstName = action.payload;
      return;
    },
    setNgsLastName(state, action) {
      state.billingInformation.lastName = action.payload;
      return;
    },
    setNgsCompany(state, action) {
      state.billingInformation.company = action.payload;
    },
    setNgsPhone(state, action) {
      const phoneRegex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
      const result = action.payload;

      // Test the regular expression with a date
      // if (phoneRegex.test(result)) {
      //   state.billingInformation.phone = result;
      // }
      state.billingInformation.phone = result;
    },
    setNgsEmail(state, action) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      state.billingInformation.email = action.payload;
    },
    setNgsShippingOption(state, action) {
      state.billingInformation.shippingOption = action.payload;
      return;
    },
    setNgsAcgtCard(state, action) {
      state.billingInformation.acgtCard = action.payload;
      return;
    },
    setNgsCCNumber(state, action) {
      state.billingInformation.ccNumber = action.payload;
      return;
    },
    setNgsCCMonth(state, action) {
      state.billingInformation.ccMonth = action.payload;
      return;
    },
    setNgsCCYear(state, action) {
      state.billingInformation.ccYear = action.payload;
      return;
    },
    setNgsCVV(state, action) {
      state.billingInformation.cvv = action.payload;
      return;
    },
	setNgsCCZip(state, action) {
      state.billingInformation.ccZip = action.payload;
      return;
    },
    setNgsCCName(state, action) {
      state.billingInformation.ccName = action.payload;
      return;
    },
    setNgsCardType(state, action) {
      state.billingInformation.cardType = action.payload;
      return;
    },
    setNgsBillingMethod(state, action) {
      state.billingInformation.billingMethod = action.payload;
      return;
    },
    setNgsPurchasingAgentName(state, action) {
      state.billingInformation.purchasingAgentName = action.payload;
      return;
    },
    setNgsPurchasingAgentEmail(state, action) {
      state.billingInformation.purchasingAgentEmail = action.payload;
      return;
    },
    setNgsPoNumber(state, action) {
      state.billingInformation.poNumber = action.payload;
      return;
    },
    setNgsOrderNumber(state, action) {
      state.data.orderNumber = action.payload;
      return;
    },
    setNgsOrderAmount(state, action) {
      state.data.orderAmount = action.payload;
      return;
    },
    setNgsGrantNumber(state, action) {
      state.billingInformation.grantNumber = action.payload;
      return;
    },
    setNgsGrantPI(state, action) {
      state.billingInformation.grantPi = action.payload;
      return;
    },
    setNgsGrantNote(state, action) {
      state.billingInformation.grantNote = action.payload;
      return;
    },
  },
  //tell our combined reducer to look for additional action types
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const {
  initializeNgsTableData,
  resetNgsState,
  resetNgsTableData,
  setNgsSampleAmount,
  addNgsRow,
  editNgsRow,
  copyNgsRow,
  deleteNgsRow,
  toggleNgsCheckbox,
  increaseNgsConcentration,
  decreaseNgsConcentration,
  clearNgsSelect,
  ngsNextStep,
  ngsPrevStep,
  ngsSetStep,
  resetNgsPage,
  initializeNgsPrimerTableData,
  setNgsPrimerAmount,
  addNgsPrimerRow,
  editNgsPrimerRow,
  deleteAllNgsPrimer,
  setNgsPrimerBanking,
  setNgsPrimerList,
  setNgsPrimerSynthesis,
  setNgsComments,
  setNgsDropoffDate,
  setNgsDropboxLocation,
  setNgsDropboxId,
  setNgsFirstName,
  setNgsLastName,
  setNgsCompany,
  setNgsPhone,
  setNgsEmail,
  setNgsShippingOption,
  setNgsAcgtCard,
  setNgsCCNumber,
  setNgsCCMonth,
  setNgsCCYear,
  setNgsCVV,
  setNgsCCZip,
  setNgsCCName,
  setNgsCardType,
  setNgsPurchasingAgentName,
  setNgsPurchasingAgentEmail,
  setNgsPoNumber,
  setNgsOrderNumber,
  setNgsOrderAmount,
  setNgsGrantNumber,
  setNgsGrantPI,
  setNgsGrantNote,
  setNgsBillingMethod,
} = ngsFormSlice.actions;
export const ngsFormReducer = ngsFormSlice.reducer;
